import { useId, type ReactNode } from "react";
import Label from "./Label";
import PlainInput, { type PlainInputProps } from "./PlainInput";

interface Props extends PlainInputProps {
  children?: ReactNode;
  feedback?: ReactNode;
}

export default function LabelAndInput({ children, feedback, ...rest }: Props) {
  const inputId = useId();
  const feedbackId = useId();

  return (
    <>
      {children && <Label htmlFor={inputId}>{children}</Label>}
      <PlainInput
        {...rest}
        id={inputId}
        aria-describedby={rest.invalid ? feedbackId : undefined}
      />
      {rest.invalid && (
        <div id={feedbackId} className="mt-1 w-full text-sm text-red-700">
          {feedback}
        </div>
      )}
    </>
  );
}
